import { Link } from "react-router-dom";
import { Factory, Globe, Zap } from "lucide-react";

const entries = [
  {
    icon: Factory,
    title: "I Run or Want to Start a Factory",
    subtext: "All Licenses, Approvals & Compliance — from Setup to Operations",
    cta: "Get All Approvals",
    href: "/environmental-compliance",
    color: "from-emerald-500 to-teal-600",
    bg: "bg-emerald-50",
    iconBg: "bg-emerald-100 text-emerald-600",
  },
  {
    icon: Globe,
    title: "I Need Carbon Solutions",
    subtext: "CCTS Compliance, Carbon Credits & Emission Management",
    cta: "Calculate My Carbon",
    href: "/carbon-ccts",
    color: "from-teal-500 to-cyan-600",
    bg: "bg-teal-50",
    iconBg: "bg-teal-100 text-teal-600",
  },
  {
    icon: Zap,
    title: "I Want to Build a Project",
    subtext: "Set up Renewable, Waste, or Carbon Projects",
    cta: "Start My Project",
    href: "/climate-projects",
    color: "from-blue-500 to-indigo-600",
    bg: "bg-blue-50",
    iconBg: "bg-blue-100 text-blue-600",
  },
];

export default function EntryBlocks() {
  return (
    <section className="py-20 bg-white" data-testid="entry-blocks">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900">How Can We Help You?</h2>
          <p className="mt-3 text-lg text-slate-600">Choose your path to environmental excellence</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {entries.map((entry, i) => (
            <div key={i} className={`${entry.bg} rounded-2xl p-8 border border-slate-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group`} data-testid={`entry-block-${i}`}>
              <div className={`w-14 h-14 rounded-xl ${entry.iconBg} flex items-center justify-center mb-6`}>
                <entry.icon className="h-7 w-7" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{entry.title}</h3>
              <p className="text-slate-600 mb-6 leading-relaxed">{entry.subtext}</p>
              <Link
                to={entry.href}
                className={`inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r ${entry.color} text-white font-semibold rounded-lg hover:opacity-90 transition-all text-sm`}
              >
                {entry.cta}
                <svg className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
